export const PageView = {
	URL: 'virtualPageURL',
	Title: 'virtualPageTitle',
};

export const Generic = {
	ProductName: 'coachProdNm',
	ProductId: 'coachProdId',
};

export const CardActions = {
	ButtonText: 'buttonText',
	ProductName: Generic.ProductName,
	ProductId: Generic.ProductId,
	Action: 'coachProgAction',
	ProgramName: 'coachProgNm',
	ProgramStart: 'coachProgStart',
	ProgramEnd: 'coachProgEnd',
	ProgramDuration: 'coachProgDuration',
	Language: 'coachLanguage',
	LevelStatus: 'coachLevelStatus',
	LevelPoints: 'coachLevelPoints',
	TaskPoints: 'coachTaskPoints',
};

export const CardProps = {
	Type: 'coachCardType',
};
